import React, { FC } from 'react';
import { UserRoleE } from '../../models/enums';
import AccessRights from '../AccessRights/AccessRights';
import Tooltip from '../Tooltip/Tooltip';

import styles from './styles.module.scss';

type RedDotPropTypes = {
    isReactProject: boolean;
}

const RedDot: FC<RedDotPropTypes> = (props) => {
    const { isReactProject } = props;

    return (
        <AccessRights accessFor={[UserRoleE.GlobalAdmin]}>
            {!isReactProject && (
                <Tooltip text='Created with the old system'>
                    <div className={styles.redDot} />
                </Tooltip>
            )}
        </AccessRights>
    );
};

export default RedDot;